// src/components/BookingPage/EmployeeSelection.js

import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';

export default function EmployeeSelection({
  employees,
  selectedEmployee,
  setSelectedEmployee,
  selectedAppointmentType,
  appointmentTypes,
}) {
  const currentType = appointmentTypes.find(t => t.id === selectedAppointmentType);

  return (
    <FormControl fullWidth>
      <InputLabel>Mitarbeiter</InputLabel>
      <Select
        value={selectedEmployee}
        label="Mitarbeiter"
        onChange={(e) => setSelectedEmployee(e.target.value)}
      >
        {employees.map(emp => {
          // Nur aktiv, wenn emp.id in assignedEmployees
          const disabled = currentType
            ? !currentType.assignedEmployees.includes(emp.id)
            : false;

          return (
            <MenuItem
              key={emp.id}
              value={emp.id}
              disabled={disabled}
              style={disabled ? { opacity: 0.5 } : {}}
            >
              {emp.name}
            </MenuItem>
          );
        })}
      </Select>
      {employees.length === 0 && (
        <FormHelperText>Keine Mitarbeiter verfügbar.</FormHelperText>
      )}
    </FormControl>
  );
}
